<script setup>
import {
  Form,
  Field,
  CellGroup,
  Button,
  Popup,
  Cascader,
  RadioGroup,
  Radio,
  DatetimePicker,
  Search
} from 'vant'
import { ref } from 'vue'
import { useCascader } from './hook/useCascader'
import { useFormData, useSubmit, useValidator } from './hook/useForm'
import { useDatePicker } from './hook/useDatePicker'
import { useBack } from '@/hooks/index.js'
import { onBeforeRouteLeave } from 'vue-router'

const props = defineProps({
  // 是否填过
  hasInfo: Boolean,
})

// 编辑态
const modifyFlag = ref(props.hasInfo ? false : true)

// 表单相关
const { formData, showFormDataList } = useFormData(props.hasInfo)
// 生日相关
const { showDatePicker, handleDatePickerConfirmClick } = useDatePicker(formData)
const searchWord = ref('')

// - -搞太多了；回头有时间优化一下这个级联
const {
  showCascader,
  cascaderValue,
  cascaderOptions,
  cascaderData,
  cascaderName,
  resultList,
  onCascaderFinish,
  handleCasCaderClick,
  handleCasCaderChange,
  handleCasCaderTabClick,
  handleSearchItemClick
} = useCascader(modifyFlag, formData, searchWord)
// 提交表单相关逻辑
const { onSubmit, submitLoading } = useSubmit(
  modifyFlag,
  props.hasInfo,
  cascaderData
)
// 表单校验相关逻辑
const { rules, formType } = useValidator()
// 返回
const { handleBack } = useBack()
const cascaderRef = ref(null)

onBeforeRouteLeave((from) => {
})
</script>
<template>
  <Form @submit="onSubmit" class="form-wrap" :readonly="!modifyFlag">
    <CellGroup inset>
      <template v-for="item in showFormDataList">
        <Field
          class="form-item"
          v-if="item.value === 'sex'"
          :name="item.value"
          label="性别"
          :rules="[{ required: true, message: '请选择性别' }]"
        >
          <template #input>
            <RadioGroup
              :disabled="!modifyFlag"
              v-model="formData[item.value]"
              direction="horizontal"
            >
              <Radio style="color: #333333" :name="1">男</Radio>
              <Radio :name="2">女</Radio>
            </RadioGroup>
          </template>
        </Field>
        <Field
          v-else-if="item.value === 'birthday'"
          v-model="formData[item.value]"
          class="form-item"
          is-link
          readonly
          name="birthday"
          :label="item.label"
          placeholder="点击选择日期"
          @click="modifyFlag && (showDatePicker = true)"
        />

        <Field
          v-else
          v-model="formData[item.value]"
          class="form-item"
          :name="item.value"
          :type="formType[item.value]"
          :label="item.label"
          :placeholder="`请输入${item.label}`"
          :rules="rules[item.value]"
        />
      </template>

      <Field
        v-model="formData.cascaderValue"
        class="form-item"
        :label="cascaderName"
        name="cascaderValue"
        :rules="[{ required: true, message: '请选择' }]"
        placeholder="请选择"
        readonly
        @click="handleCasCaderClick"
      />
    </CellGroup>
    <div class="footer">
      <div class="btn-wrap">
        <template v-if="hasInfo">
          <template v-if="modifyFlag">
            <Button
              class="btn cancel"
              round
              block
              @click="modifyFlag = false"
              :loading="submitLoading"
            >
              取消
            </Button>
            <Button
              class="btn"
              round
              block
              native-type="submit"
              :loading="submitLoading"
            >
              确认
            </Button>
          </template>
          <template v-else>
            <Button
              class="btn cancel"
              round
              block
              @click="handleBack"
              :loading="submitLoading"
            >
              返回
            </Button>
            <Button
              class="btn"
              round
              block
              @click="modifyFlag = true"
              :loading="submitLoading"
            >
              编辑
            </Button>
          </template>
        </template>
        <Button
          v-else
          class="single-btn"
          round
          block
          type="primary"
          native-type="submit"
          :loading="submitLoading"
        >
          去作答
        </Button>
      </div>
    </div>
  </Form>
  <!-- 日期弹框 -->
  <Popup v-model:show="showDatePicker" round position="bottom">
    <DatetimePicker
      v-model:show="showDatePicker"
      type="date"
      :min-date="new Date(1900, 0, 1)"
      :max-date="new Date()"
      @cancel="showDatePicker = false"
      @confirm="handleDatePickerConfirmClick"
    />
  </Popup>

  <!-- 级联弹窗 -->
  <Popup v-model:show="showCascader" round position="bottom">
    <Cascader
      ref="cascaderRef"
      id="info-cascader"
      v-model="cascaderValue"
      title="请选择"
      active-color="#1d7dff"
      :field-names="{
        value: 'id',
        text: 'name',
      }"
      :options="cascaderOptions"
      @clickTab="handleCasCaderTabClick"
      @change="handleCasCaderChange"
      @finish="onCascaderFinish"
      @close="showCascader = false"
    >
    <template #title>
        <div>
          <div>请选择</div>
          <Search v-model="searchWord" placeholder="请输入当前层级搜索关键词" />
          <ul v-if="searchWord" class="result-list">
            <li @click="handleSearchItemClick(item, index)" v-for="item, index in resultList" class="result-item">{{ item.name }}</li>
          </ul>
        </div>
      </template>
    </Cascader>
  </Popup>
</template>

<style lang="scss" scoped>
::v-deep {
  .van-field__label {
    width: 140px;
    margin-right: 0;
    font-size: 16px;
  }

  .van-field__body {
    font-size: 16px;
  }

  .van-field__error-message {
    font-size: 14px;
    position: absolute;
    top: 21px;
    right: 0;
  }

  .van-cascader__title {
    width: 100%;
  }

  .van-cascader__header {
    padding: 10px;
    height: auto;
  }
}
</style>

<style lang="scss" scoped>
.form-wrap {
  margin: 0 25px;
  padding-bottom: 179px;
  .form-item {
    box-sizing: border-box;
    padding: 51px 0;
    border-bottom: 1px solid rgba($color: #999999, $alpha: 0.1);
  }
  ::v-deep {
    .van-field__control {
      text-align: right;
      color: #333333;
    }

    .van-radio__label {
      color: #333333 !important;
    }

    .van-radio-group--horizontal {
      width: 100%;
      justify-content: flex-end;

      .van-radio--horizontal {
        margin-right: 0;
        margin-left: 10px;
      }
    }

    .van-field__label {
      position: relative;
      padding-left: 10px;

      &::after {
        position: absolute;
        content: '';
        top: 2px;
        bottom: 2px;
        left: 0;
        width: 3px;
        background: linear-gradient(-59deg, #1d7dff 0%, #4e94fe 100%);
        border-radius: 3px;
      }
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 179px;
  background: #ffffff;
  box-shadow: 0px 0px 21px 0px rgba(198, 198, 198, 0.3);
  border-radius: 10px;

  .btn-wrap {
    margin: 0 auto;
    margin-top: 26px;
    width: 700px;
    display: flex;
    justify-content: space-between;

    .btn {
      width: 335px;
      height: 80px;
      background: linear-gradient(-36deg, #21a9ff, #3594ff);
      border-radius: 40px;
      font-size: 30px;
      color: #ffffff;
    }

    .cancel {
      background: #c6c6c6;
    }

    .single-btn {
      width: 100%;
      background: linear-gradient(-36deg, #21a9ff, #3594ff);
    }
  }
}

.result-list {
  position: absolute;
  top: 150px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  font-size: 30px;
  background-color: #fff;
  overflow-y: auto;
  z-index: 2;

  .result-item {
    padding: 10px 0;
    line-height: 1.4;
  }
}
</style>
